module.exports = __webpack_public_path__ + "static/media/cash-register.b363083d.svg";